import styled from "styled-components";

export const Container = styled.div`
  border-radius: 5px;
  padding: 4px 8px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral90};
  color: ${({ theme }) => theme.colors.white};
`;